var map = {
	"./symbol_0.png": 32784,
	"./symbol_1.png": 48537,
	"./symbol_10.png": 19773,
	"./symbol_11.png": 98644,
	"./symbol_12.png": 17551,
	"./symbol_2.png": 34530,
	"./symbol_3.png": 98187,
	"./symbol_4.png": 6196,
	"./symbol_5.png": 27325,
	"./symbol_6.png": 59910,
	"./symbol_7.png": 28655,
	"./symbol_8.png": 27000,
	"./symbol_9.png": 99713
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 76739;